import React from 'react'
import { useDisclosure, VStack, Box, Flex, FormLabel, Spacer, Button, Icon } from '@chakra-ui/react'
import { Card } from 'components/card/card'
import {AddNewPropertyModal} from 'features/property/add-new-property-modal'
import { PropertyTable } from 'features/property/property-table'
import { useTranslation } from 'react-i18next'
import { BiBookAdd } from 'react-icons/bi'

const Property: React.FC = props => {
  const { t } = useTranslation()

  const {
    isOpen: isOpenNewPropertyModal,
    onClose: onNewPropertyModalClose,
    onOpen: onNewPropertyModalOpen,
  } = useDisclosure()

  return (
    <>
      <VStack alignItems="start" minH="calc(100vh - 160px)" pb="2">
        <Card
          w="100%"
          py="14px"
          px="14px"
          boxShadow="0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)"
        >
          <Flex w="100%" mb="14px" alignItems={'center'}>
            {/* <Flex alignItems="center" pl={2}> */}
            <FormLabel variant="strong-label" size="lg" whiteSpace="nowrap" m="0" fontSize="18px">
              {t('property.titleLabel')}
            </FormLabel>
            <Spacer />

            <Button onClick={onNewPropertyModalOpen} colorScheme="brand" fontSize="14px" minW={'140px'}>
              <Icon as={BiBookAdd} fontSize="18px" mr={2} />
              {t('property.newProperty')}
            </Button>
          </Flex>

          <Box w="100%" minH="500px">
            <PropertyTable />
          </Box>
        </Card>
        <AddNewPropertyModal isOpen={isOpenNewPropertyModal} onClose={onNewPropertyModalClose} />
      </VStack>
    </>
  )
}

export default Property
